<template>
  <div>
    <v-layout
      row
      wrap
      class="layout"
    >
      <template v-if="categoryDisplayStyle == 0">
        <horizontal-scroll class="maincat">
          <div
            v-for="(c, index) in parentCats"
            :key="index"
            :style="myModeStyle(c, index)"
            @click="selectCat(c.category_id)"
            :id="c.category_id"
          >
            <span>{{ catName(c) }}</span>
          </div>
        </horizontal-scroll>
      </template>
      <template v-else>
        <div class="category-display-tiled">
          <div
            v-for="(c, index) in parentCats"
            :key="index"
            :style="myModeStyle(c, index)"
            @click="selectCat(c.category_id)"
            :id="c.category_id"
          >
            <span>{{ catName(c) }}</span>
          </div>
        </div>
      </template>
    </v-layout>
    <div v-if="childrenCatList && childrenCatList.length > 0">
      <div
        v-for="(c, index) in childrenCatList"
        :key="index"
      >
        <cat-list
          :cat="c"
          :open-panel="expand1stCat(index, c)"
        />
      </div>
    </div>
    <progress-bar :show="loading" style="margin-top: 80px;" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HorizontalScroll from 'vue-horizontal-scroll'
import CatList from '~/components/CatList2'

export default {
  name: 'cat-list-component',
  components: {
    'horizontal-scroll': HorizontalScroll,
    'cat-list': CatList
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'config', 'language', 'categoryDisplayStyle'
    ]),
    ...mapGetters('menu', [
      'items', 'catList', 'parentCats', 'childrenCatList',
      'mainCat', 'selectedPanel'
    ]),
  },
  methods: {
    expand1stCat (index,c) {
      const selected = this.childrenCatList.find(cl => cl.category_id === this.selectedPanel)
      if (selected && selected.category_id === c.category_id && selected.parent_id === this.mainCat) {
        return (this.selectedPanel === c.category_id)
      }
      // normal
      return (index === 0)
    },
    myModeStyle (category) {
      let styles = {
        fontSize: '14px',
        color: this.theme.toolbar_color,
        backgroundColor: this.theme.toolbar_bg_color,
        display: 'inline-block',
        marginRight: '8px',
        padding: '8px 8px',
        borderRadius: '3px',
        cursor: 'pointer',
        // width: '150px',
        textAlign: 'center'
      }

      if (this.categoryDisplayStyle == 1) {
        styles = Object.assign(styles, {
          flexGrow: 1,
          margin: '2px 0 0 2px',
          // height: '38px',
        })
      }

      if (category.category_id === this.mainCat) {
        styles.fontSize = '16px'
        styles.fontWeight = 900
      }

      let catName = this.catName(category);
      if (catName && catName.length < 12) {
        styles.width = '150px';
      } else {
        styles.width = this.catName(category).length * 12.5 + 'px'
      }

      return styles
    },
    catName (cat) {
      if (this.language !== 'en-SG') {
        let name = cat.alternate_name || cat.alternativeName || cat.name
        return name.length > 30 ? name.substring(0, 30) + '...' : name
      }
      return cat.name.length > 30 ? cat.name.substring(0, 30) + '...' : cat.name
    },
    selectCat (id) {
      if (this.mainCat === id) return
      this.$store.dispatch('menu/setMainCat', id)
      this.$store.dispatch('menu/resetSelectedPanel')
      var div = $('#'+event.currentTarget.id);
      var pos =  div.offset().left/1.1 + div.outerWidth(true)/2 + $('._horizontal-scroll.maincat').scrollLeft() - $('._horizontal-scroll.maincat').width()/2;
      $('._horizontal-scroll.maincat').scrollLeft(pos)
    },
  },
  watch: {
    mainCat (val) {
      var div = $('#'+val);
      var pos =  div.offset().left/1.1 + div.outerWidth(true)/2 + $('._horizontal-scroll').scrollLeft() - $('._horizontal-scroll.maincat').width()/2;
      $('._horizontal-scroll').scrollLeft(pos)
    }
  },
  mounted () {
    // if(this.parentCats.length >0)
    // {
    //   this.selectCat(this.mainCat);
    // }
    var div = $('#'+this.mainCat);
    var pos =  div.offset().left + div.outerWidth(true)/2 + $('._horizontal-scroll').scrollLeft() - $('._horizontal-scroll').width()/2;
    $('._horizontal-scroll').scrollLeft(pos)
  }
}
</script>

<style scoped>
.layout {
  margin-top: -10px;
  margin-bottom: 12px;
}
.category-display-tiled {
  display: flex;
  flex-wrap:wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/MainCatList.vue